import { atom, createStore } from "jotai";
import { Salon } from "../interfaces/services/Salon";
import { MeResp } from "../interfaces/services/Auth";

export const myStore = createStore();

export const salonAtom = atom<Salon | null>(null);

export const meAtom = atom<MeResp>();

myStore.set(salonAtom, null);
